import { render, staticRenderFns } from "./Menu_.vue?vue&type=template&id=78ab8bc3&scoped=true"
import script from "./Menu_.vue?vue&type=script&lang=js"
export * from "./Menu_.vue?vue&type=script&lang=js"
import style0 from "./Menu_.vue?vue&type=style&index=0&id=78ab8bc3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ab8bc3",
  null
  
)

export default component.exports